import * as _positions from './positions';
import * as _contents from './contents/index';
import './style/index.less';

export { PopoverView } from './popover-view';
export const positions = _positions;
export const contents = _contents;
